import brandLogo from "../assets/brand/logo.png";

interface BrandIdentityProps {
  inverse?: boolean;
  showSubtitle?: boolean;
}

export function BrandIdentity({ inverse = false, showSubtitle = true }: BrandIdentityProps) {
  return (
    <span className={`brand-identity${inverse ? " brand-identity--inverse" : ""}`}>
      <img className="brand-logo" src={brandLogo} alt="" aria-hidden="true" />
      <span className="brand-copy">
        <strong>版权登记材料管理系统</strong>
        {showSubtitle ? <small>DOCUMENTATION REGISTRY</small> : null}
      </span>
    </span>
  );
}
